/* eslint-disable max-len */
/* eslint-disable no-case-declarations */
"use strict";

const {
    ProductQuery,
    TranslationsQuery,
    ProductsQuery,
    CategoryTranslationsQuery
} = require("./helpers/productGraphQLQueries");
const config = require("./helpers/configuration");
const { fromJsonString, getProp, isNullOrEmpty } = require("@nuskin/ns-common-lib");
const { default: axios } = require("axios");

let envConfig = {};
let activeSalesEvents = ["unitTestsNeedAnEvent"];

const processProps = (props) => {
    if (!props) {
        return "empty";
    } else if (props.fromId) {
        if (!props.env || !["dev", "test", "prod"].includes(props.env)) {
            return "missingEnv";
        } else {
            return "id";
        }
    } else if (props.fromSlug) {
        if (!props.env || !["dev", "test", "prod"].includes(props.env)) {
            return "missingEnv";
        } else {
            return "slug";
        }
    } else if (props.data) {
        if (!props.env || !["dev", "test", "prod"].includes(props.env)) {
            return "missingEnv";
        } else {
            return "data";
        }
    }
};

const isNullOrFieldsEmpty = (variable) => {
    if (isNullOrEmpty(variable)) {
        return true;
    }
    if (typeof variable === "object") {
        let isEmpty = true;
        for (const key in variable) {
            if (Object.hasOwnProperty.call(variable, key)) {
                if (!isNullOrFieldsEmpty(variable[key])) {
                    isEmpty = false;
                }
            }
        }
        return isEmpty;
    }
    return false;
};

const getProductById = async (id, market, language, useContentSource) => {
    const payload = { variables: { market, language, id, useContentSource } };
    payload.operationName = "ProductById";
    payload.query = `query ProductById($id: String!, $market: String, $language: String, $useContentSource: String) {
            productById(id: $id, market: $market, language: $language, useContentSource: $useContentSource) {
              ${ProductQuery}}}`;
    try {
        const idRes = await axios.post(`${envConfig.graphqlUrl}`, payload);
        return (((idRes || {}).data || {}).data || {}).productById || (idRes || {}).error;
    } catch (ex) {
        console.error(ex);
    }
};

const getProductsById = async (ids, market, language, useContentSource, quantity, okta, env) => {
    env = env || "prod";
    market = market || "US";
    language = language || "en";
    envConfig = config.getConfig(env);
    const payload = { variables: { ids, market, language, useContentSource, quantity, okta } };
    payload.operationName = "ProductsById";
    payload.query = `query ProductsById($ids: [String!]!, $market: String, $language: String, $useContentSource: String, $quantity: Int, $okta: String) {
        productsById(ids: $ids, market: $market, language: $language, useContentSource: $useContentSource, quantity: $quantity, okta: $okta) {
          validCount
          totalCount
          skip
          ${ProductsQuery}
        }
      }`;
    try {
        const data = await axios.post(`${envConfig.graphqlUrl}`, payload);
        return (((data || {}).data || {}).data || {}).productsById || (data || {}).errors;
    } catch (ex) {
        console.error(ex);
    }
};

const getProductBySlug = async (slug, market, language, useContentSource) => {
    const payload = { variables: { market, language, slug, useContentSource } };
    payload.operationName = "ProductBySlug";
    payload.query = `query ProductBySlug($slug: String!, $market: String, $language: String, $useContentSource: String) {
              productBySlug(slug: $slug, market: $market, language: $language, useContentSource: $useContentSource) {
                ${ProductQuery}}}`;
    try {
        const idRes = await axios.post(`${envConfig.graphqlUrl}`, payload);
        return (((idRes || {}).data || {}).data || {}).productBySlug || (idRes || {}).error;
    } catch (ex) {
        console.error(ex);
    }
};

const getPublishedProducts = async (market, language, env, useContentSource) => {
    envConfig = config.getConfig(env);
    const payload = { variables: { market, language, limit: 700, useContentSource } };
    payload.operationName = "PublishedProducts";
    payload.query = `query PublishedProducts($market: String, $language: String, $limit: Int, $useContentSource: String) {
              publishedProducts(market: $market, language: $language, limit: $limit, useContentSource: $useContentSource) {
                totalCount
                validCount
                productIds
              }}`;
    try {
        const idRes = await axios.post(`${envConfig.graphqlUrl}`, payload);
        return (((idRes || {}).data || {}).data || {}).publishedProducts || (idRes || {}).error;
    } catch (ex) {
        console.error(ex);
    }
};

const getActiveSalesEvents = async (market) => {
    envConfig = envConfig || config.getConfig('test');
    const activeEvents = [{ eventName: 'unitTestsNeedAnEvent' }]
    let res = axios.get(envConfig.activeEventUrl, { headers: { client_id: envConfig.clientId } });
    res = await res;
    for (const event of (res.data || {}).salesEventResponse || []) {
        if (event.startTimestamp < Date.now() && event.endTimestamp > Date.now() && event.eventEnabled) {
            if (event.markets.includes(market)) {
                activeEvents.push({ ...event })
            }
        }
    }
    activeSalesEvents = activeEvents
    return activeSalesEvents;
};

const setActiveSalesEvents = (events) => {
    activeSalesEvents = events || [];
};

const getPDPStrings = async (market, language, env) => {
    env = env || "prod";
    market = market || "US";
    language = language || "en";
    envConfig = config.getConfig(env);
    const payload = { variables: { market, language } };
    payload.operationName = "PdpStrings";
    payload.query = `query PdpStrings($market: String, $language: String) {
        pdpStrings(market: $market, language: $language) {
              ${TranslationsQuery}}}`;
    try {
        const res = await axios.post(`${envConfig.graphqlUrl}`, payload);
        return (((res || {}).data || {}).data || {}).pdpStrings || (res || {}).error;
    } catch (ex) {
        console.error(ex);
    }
};

const getCPStrings = async (market, language, env) => {
    env = env || "prod";
    market = market || "US";
    language = language || "en";
    envConfig = config.getConfig(env);
    const payload = { variables: { market, language } };
    payload.operationName = "CpStrings";
    payload.query = `query CpStrings($market: String, $language: String) {
        cpStrings(market: $market, language: $language) {
              ${CategoryTranslationsQuery}}}`;
    try {
        const res = await axios.post(`${envConfig.graphqlUrl}`, payload);
        return (((res || {}).data || {}).data || {}).cpStrings || (res || {}).error;
    } catch (ex) {
        console.error(ex);
    }
};

/*
    This is the "constructor" for a nuskin product object. 
    You send it an object that will be used to determine what to do  when it initializes
    Possible options:
        {} - Create an empty nsProduct object with no data
        {data: Object} - Create an object using the data previously retrived from the product graphql
        {fromId: String, market: String, language: String, env: String} - Create an object using data retrieved using the ID, market, language, environment sent
        {fromSlug: String, market: String, language: String, env: String} - Create an object using data retrieved using the slug, market, language, environment sent

    Example usage:
        const product = await nsProduct({fromSlug: 'tegreen', market: 'US', language: 'en', env: 'dev'});
        const fromSku = await nsProduct({fromId: '01003440', market: 'US', language: 'en', env: 'dev'});
        const fromUid = await nsProduct({fromId: 'blta50746fc33f83470', market: 'US', language: 'en', env: 'dev'});
*/
const getProduct = async (props) => {
    let data = {};
    let productSource = {};
    // Validate props passed in
    const constructorType = processProps(props);
    if (constructorType === "missingEnv") {
        data.error = "Missing env in props, please include the environment and re-initialize";
    } else if (["id", "slug", "data"].includes(constructorType)) {
        // initialize configs and libs
        envConfig = config.getConfig(props.env);
    }
    // Initialize NsProduct based on constructor used
    switch (constructorType) {
        case "id":
            data =
                (await getProductById(
                    props.fromId,
                    props.market || "US",
                    props.language || "en",
                    props.useContentSource
                )) || {};
            productSource = data.productDataSource || {};
            productSource.market = productSource.market || props.market || "US";
            productSource.language = productSource.language || props.language || "en";
            data.productDataSource = productSource;
            break;
        case "slug":
            data =
                (await getProductBySlug(
                    props.fromSlug,
                    props.market || "US",
                    props.language || "en",
                    props.useContentSource
                )) || {};
            productSource = data.productDataSource || {};
            productSource.market = productSource.market || props.market || "US";
            productSource.language = productSource.language || props.language || "en";
            data.productDataSource = productSource;
            break;
        case "data":
            productSource = {
                ...props.data.productDataSource,
                market: (props.data.productDataSource || {}).market || props.market || "US",
                language: (props.data.productDataSource || {}).language || props.language || "en"
            };
            props.data.productDataSource = productSource;
            data = props.data;
            break;
    }

    /* istanbul ignore next */
    const removeDiscounts = (facet, facetName, promotions, quantity) => {
        const activeSubscriberPromotionName = "10% off for active subscriber"
        const bundlePromotionName = "Price Offer for Bundle"
        const subscribeAndSavePromoName = "Subscriber 10% Benefit"
        if (facet && typeof (facet[facetName]) !== 'undefined' && typeof (facet[`${facetName}AfterDiscount`]) !== 'undefined') {
            if (facet[facetName] === facet[`${facetName}AfterDiscount`]) {
                facet[`${facetName}AfterDiscount`] = null
            } else {
                const bundlePromotion = promotions.find(p => p.message === bundlePromotionName) || {}
                const activeSubscriberPromo = promotions.find(p => p.message === activeSubscriberPromotionName) || {}
                const subscribeAndSavePromo = promotions.find(p => p.message === subscribeAndSavePromoName) || {}
                let regularPrice = facet[`${facetName}AfterDiscount`]
                let originalPrice = regularPrice
                const bundlePrice = facet[facetName]
                if (!isNullOrFieldsEmpty(bundlePromotion) && !isNullOrFieldsEmpty(activeSubscriberPromo)) {
                    regularPrice += (activeSubscriberPromo.priceFacets[`${facetName}Discount`] * quantity)
                    //regularPrice = (regularPrice + bundlePromotion.priceFacets[`${facetName}Discount`] * quantity)
                    facet[`${facetName}Original`] = bundlePrice
                    facet[facetName] = regularPrice
                } else if (!isNullOrFieldsEmpty(bundlePromotion)) {
                    originalPrice = bundlePrice - (bundlePromotion.priceFacets[`${facetName}Discount`] * quantity)
                    facet[`${facetName}Original`] = bundlePrice
                    facet[facetName] = originalPrice
                } else if (!isNullOrFieldsEmpty(activeSubscriberPromo)) {
                    originalPrice += (activeSubscriberPromo.priceFacets[`${facetName}Discount`] * quantity)
                }
                if (!isNullOrEmpty(subscribeAndSavePromo)) {
                    originalPrice += (subscribeAndSavePromo.priceFacets[`${facetName}Discount`] * quantity)
                    facet[`${facetName}AfterDiscount`] = originalPrice
                }

                const extraPromotions = promotions.filter(p => ![bundlePromotionName, activeSubscriberPromotionName, subscribeAndSavePromoName].includes(p.message))
                if (!extraPromotions || !Array.isArray(extraPromotions) || extraPromotions.length === 0) {
                    facet[`${facetName}AfterDiscount`] = null
                }

                if (facet[`${facetName}AfterDiscount`] === facet[facetName]) {
                    facet[`${facetName}AfterDiscount`] = null
                }
            }
        }
        return facet || {}
    }

    const getEqPricing = async (variant, bundle, selectedSkus, quantity, okta, productInBundleId) => {
        if (isNullOrEmpty(variant) && isNullOrEmpty(bundle)) {
            return {};
        }
        quantity = quantity || 1;
        const eqData = data.productDataSource;
        let eqHeaders = {
            "Content-Type": "application/json"
        };
        const oktaToken = okta || null;
        if (oktaToken) {
            eqHeaders.Authorization = "Bearer " + oktaToken;
        }
        if (
            !(
                eqData &&
                eqData.apiBaseUrl &&
                eqData.market &&
                eqData.language &&
                (productInBundleId || data.id) &&
                eqData.storeId
            )
        ) {
            console.log(`Missing required Equinox URL params to get Equinox Pricing: ${JSON.stringify(eqData)}`);
        }
        const eqUrl = `${eqData.apiBaseUrl}/orchestrationservices/storefront/catalogs/products/${productInBundleId || data.id
        }/promotions?locale=${eqData.language}_${eqData.market.toUpperCase()}&storeId=${eqData.storeId}`;
        const body = {
            categoryId: ["all_products"],
            quantity: quantity.toString(),
            productId: productInBundleId || data.id,
            isSubscriptionIncludedInPromotion: false,
            isFromBrowse: true
            // isSubscriptionPromotion: true -- Removed (possibly temporarily) due to pricing discrepancies when it's set --
        }
        let currencyCode;
        if (!isNullOrFieldsEmpty(variant)) {
            body.skus = [{ skuId: variant.sku, productId: productInBundleId || data.id, type: 'DEFAULT' }]
            currencyCode = variant.price && variant.price.currencyCode;
        } else if (!isNullOrFieldsEmpty(bundle)) {
            currencyCode = bundle.price && bundle.price.currencyCode;
            selectedSkus = selectedSkus || []
            const skus = []
            const variantsGettingPriced = []
            for (const bundleItem of data.bundle.kitProducts) {
                const variants = bundleItem.product.variants || [];
                let variant = variants[0];
                if (variants.length > 0 && selectedSkus.some((r) => variants.map((s) => s.sku).includes(r))) {
                    variant = (variants.filter((v) => selectedSkus.includes(v.sku)) || [])[0] || variant;
                    variantsGettingPriced.push(
                        getEqPricing(variant, null, null, bundleItem.quantity, okta, (bundleItem.product || {}).id)
                    );
                } else if (!bundleItem.isMandatory) {
                    variant = null;
                }
                if (variant) {
                    skus.push({
                        skuId: variant.sku,
                        productId: bundleItem.product.id,
                        quantity: bundleItem.quantity,
                        type: "kit"
                    });
                }
            }
            body.skus = skus;
            for (const pricing of variantsGettingPriced) {
                await pricing;
            }
        }
        try {
            let res = axios.post(eqUrl, { ...body }, { headers: { ...eqHeaders } });
            res = await res;
            const isSubscribeAndSave = ((res || {}).data || {}).isSubscribeSaveEnabled || false
            const buyOnce = ((res || {}).data || {}).totalValue || {};
            const promotion = ((res || {}).data || {}).promotion || [];
            const onceFacet = buyOnce.priceFacets || {};
            const wholesale = removeDiscounts(onceFacet["Wholesale Price"], "Wholesale Price", promotion, quantity);
            const retail = removeDiscounts(onceFacet["Regular Price"], "Regular Price", promotion, quantity);
            const cv = removeDiscounts(onceFacet["CV"], "CV", promotion, quantity);
            const pv = removeDiscounts(onceFacet["PV"], "PV", promotion, quantity);
            const sb = removeDiscounts(onceFacet["SB"], "SB", promotion, quantity);
            const priceObject = {
                currencyCode,
                retail: retail['Regular Price'],
                retailSales: retail['Regular PriceAfterDiscount'],
                retailSubscription: retail['Regular PriceAfterDiscount'] || retail['Regular Price'],
                retailOriginal: retail['Regular PriceOriginal'] || null,
                wholesale: wholesale['Wholesale Price'],
                wholesaleSales: wholesale['Wholesale PriceAfterDiscount'],
                wholesaleSubscription: wholesale['Wholesale PriceAfterDiscount'] || wholesale['Wholesale Price'],
                wholesaleOriginal: wholesale['Wholesale PriceOriginal'] || null
            }

            if (isSubscribeAndSave) {
                priceObject.retailSubscription = Number(Number(priceObject.retailSubscription * .9).toFixed(2))
                priceObject.wholesaleSubscription = Number(Number(priceObject.wholesaleSubscription * .9).toFixed(2))
            }

            const pointsObject = {
                subscription: {
                    cv: cv.CVAfterDiscount || cv.CV,
                    pv: pv.PVAfterDiscount || pv.PV,
                    sb: sb.SBAfterDiscount || sb.SB
                },
                wholesale: {
                    cv: cv.CVAfterDiscount || cv.CV,
                    pv: pv.PVAfterDiscount || pv.PV,
                    sb: sb.SBAfterDiscount || sb.SB
                }
            };

            if (!isNullOrFieldsEmpty(bundle)) {
                // priceObject.retailOriginal = bundle.price.retailOriginal ? bundle.price.retailOriginal * quantity : null
                // priceObject.wholesaleOriginal = bundle.price.wholesaleOriginal ? bundle.price.wholesaleOriginal * quantity : null
                if (!isNullOrFieldsEmpty(bundle.points.original)) {
                    pointsObject.original = {
                        cv: bundle.points.original.cv ? bundle.points.original.cv * quantity : null,
                        pv: bundle.points.original.pv ? bundle.points.original.pv * quantity : null,
                        sb: bundle.points.original.sb ? bundle.points.original.sb * quantity : null
                    }
                }
            }

            const promotions = (((res || {}).data || {}).promotion || []).map(function (promo) {
                return {
                    offerId: promo.offerId,
                    promotionClass: promo.promotionClass,
                    discount: promo.discount,
                    message: promo.message
                };
            });

            if (!isNullOrFieldsEmpty(variant)) {
                //data.variants.find(({sku}) => sku === skuIfNotFirstVariant)
                variant.totalPrice = priceObject;
                variant.totalPoints = pointsObject;
                variant.promotions = promotions;
                if (quantity === 1) {
                    variant.price = priceObject;
                    variant.points = pointsObject;
                }
            } else if (!isNullOrEmpty(bundle)) {
                bundle.totalPrice = priceObject;
                bundle.totalPoints = pointsObject;
                bundle.promotions = promotions;
                if (quantity === 1) {
                    bundle.price = priceObject;
                    bundle.points = pointsObject;
                }
            }

            return {
                points: pointsObject,
                price: priceObject,
                promotions: promotions
            };
        } catch (ex) {
            console.log(ex);
            return {};
        }
    };

    const getCsPricing = async (variant, bundle, selectedSkus, quantity, okta, market) => {
        market = market ? market.toUpperCase() : null
        if (isNullOrEmpty(variant) && isNullOrEmpty(bundle)) {
            return {};
        }
        if (!isNullOrFieldsEmpty(variant)) {
            const promotions = [];
            const activeSalesEvents = await getActiveSalesEvents(market);
            let sku = variant;
            if (!sku || !sku.pricingJson) {
                return;
            }
            const pricing = fromJsonString(sku.pricingJson, {});
            const pricingRetail = pricing.retail || {};
            const pricingWholesale = pricing.wholesale || {};
            let priceObject = sku.price ? { ...sku.price } : {};
            let pointsObject = sku.points
                ? { wholesale: { ...sku.points.wholesale }, subscription: { ...sku.points.subscription } }
                : {};
            for (const activeEvent of activeSalesEvents) {
                let retailPrice = getProp(pricing, `retail.${activeEvent.eventName}.price`, null);
                priceObject.retailSales = isNullOrEmpty(retailPrice) ? priceObject.retailSales : retailPrice * quantity;
                const retail = pricingRetail.webOrder || pricingRetail.order;
                priceObject.retail = isNullOrEmpty(retail) ? priceObject.retail : retail.price * quantity;
                priceObject.retailSubscription =
                    isNullOrEmpty(pricingRetail.webAdr) || !pricingRetail.webAdr.price
                        ? null
                        : pricingRetail.webAdr.price * quantity;

                let wholesalePrice = getProp(pricing, `wholesale.${activeEvent.eventName}.price`, null);
                priceObject.wholesaleSales = isNullOrEmpty(wholesalePrice) ? priceObject.wholesaleSales : wholesalePrice * quantity;
                const wholesale = pricingWholesale.webOrder || pricingWholesale.order;
                priceObject.wholesale = isNullOrEmpty(wholesale) ? priceObject.wholesale : wholesale.price * quantity;

                const wholesaleSubscriptionPrice = pricingWholesale.ADR5 || pricingWholesale.WADW || pricingWholesale.webAdr;

                priceObject.wholesaleSubscription =
                    isNullOrEmpty(wholesaleSubscriptionPrice) || !wholesaleSubscriptionPrice.price
                        ? null
                        : wholesaleSubscriptionPrice.price * quantity;

                let wholesaleCv = getProp(pricing, `wholesale.${activeEvent.eventName}.cv`, null);
                pointsObject.wholesale.cv = isNullOrEmpty(wholesaleCv) ? pointsObject.wholesale.cv : wholesaleCv * quantity;
                if (!pointsObject.wholesale.cv) {
                    pointsObject.wholesale.cv = wholesale.cv ? wholesale.cv * quantity : null;
                }
                pointsObject.subscription.cv =
                    isNullOrEmpty(wholesaleSubscriptionPrice) || !wholesaleSubscriptionPrice.cv
                        ? null
                        : wholesaleSubscriptionPrice.cv * quantity;

                let wholesalePv = getProp(pricing, `wholesale.${activeEvent.eventName}.pv`, null);
                pointsObject.wholesale.pv = isNullOrEmpty(wholesalePv) ? pointsObject.wholesale.pv : wholesalePv * quantity;
                if (!pointsObject.wholesale.pv) {
                    pointsObject.wholesale.pv = wholesale.pv ? wholesale.pv * quantity : null;
                }
                pointsObject.subscription.pv =
                    isNullOrEmpty(wholesaleSubscriptionPrice) || !wholesaleSubscriptionPrice.pv
                        ? null
                        : wholesaleSubscriptionPrice.pv * quantity;

                let wholesaleSb = getProp(pricing, `wholesale.${activeEvent.eventName}.SB`, null);
                pointsObject.wholesale.sb = isNullOrEmpty(wholesaleSb) ? pointsObject.wholesale.sb : wholesaleSb * quantity;
                if (!pointsObject.wholesale.sb) {
                    pointsObject.wholesale.sb = wholesale.sb ? wholesale.sb * quantity : null;
                }
                pointsObject.subscription.sb =
                    isNullOrEmpty(wholesaleSubscriptionPrice) || !wholesaleSubscriptionPrice.sb
                        ? null
                        : wholesaleSubscriptionPrice.sb * quantity;
                promotions.push({ offerId: activeEvent.eventName, promotionClass: "salesEvent", startTimestamp: activeEvent.startTimestamp, endTimestamp: activeEvent.endTimestamp, eventEnabled: activeEvent.eventEnabled, markets: activeEvent.markets });
            }

            sku.totalPrice = priceObject;
            sku.totalPoints = pointsObject;
            sku.promotions = promotions;
            if (quantity === 1) {
                sku.price = priceObject;
                sku.points = pointsObject;
            }
            return { price: priceObject, points: pointsObject, promotions: promotions };
        }
        if (!isNullOrFieldsEmpty(bundle)) {
            selectedSkus = selectedSkus || [];
            const variantsGettingPriced = [];
            for (const bundleItem of data.bundle.kitProducts) {
                const variants = bundleItem.product.variants || [];
                for (const variant of variants) {
                    if (selectedSkus.some((r) => variant.sku === r)) {
                        variantsGettingPriced.push({
                            ...(await getCsPricing(variant, null, null, 1, okta, market)),
                            sku: variant.sku,
                            bundleQuantity: quantity,
                            variantQuantity: bundleItem.quantity
                        });
                    }
                }
            }

            let retail = 0;
            let retailSales = 0;
            let retailSubscription = 0;
            let wholesale = 0;
            let wholesaleSales = 0;
            let wholesaleSubscription = 0;
            let subscribeCV = 0;
            let subscribePV = 0;
            let subscribeSB = 0;
            let wholesaleCV = 0;
            let wholesalePV = 0;
            let wholesaleSB = 0;
            let offerId = "";
            let promotionClass = "";
            let discount = "";
            let message = "";

            variantsGettingPriced.forEach((v) => {
                retail = retail + (v.price || {}).retail * v.variantQuantity;
                retailSales = retailSales + (v.price || {}).retailSales * v.variantQuantity;
                retailSubscription = retailSubscription + (v.price || {}).retailSubscription * v.variantQuantity;
                wholesale = wholesale + (v.price || {}).wholesale * v.variantQuantity;
                wholesaleSales = wholesaleSales + (v.price || {}).wholesaleSales * v.variantQuantity;
                wholesaleSubscription =
                    wholesaleSubscription + (v.price || {}).wholesaleSubscription * v.variantQuantity;
                subscribeCV = subscribeCV + ((v.points || {}).subscription || {}).cv * v.variantQuantity;
                subscribePV = subscribePV + ((v.points || {}).subscription || {}).pv * v.variantQuantity;
                subscribeSB = subscribeSB + ((v.points || {}).subscription || {}).sb * v.variantQuantity;
                wholesaleCV = wholesaleCV + ((v.points || {}).wholesale || {}).cv * v.variantQuantity;
                wholesalePV = wholesalePV + ((v.points || {}).wholesale || {}).pv * v.variantQuantity;
                wholesaleSB = wholesaleSB + ((v.points || {}).wholesale || {}).sb * v.variantQuantity;
                offerId = ((v.promotions || [])[0] || {}).offerId;
                promotionClass = ((v.promotions || [])[0] || {}).promotionClass;
                discount = ((v.promotions || [])[0] || {}).discount;
                message = ((v.promotions || [])[0] || {}).message;
            });

            retail = retail * quantity;
            retailSales = retailSales * quantity;
            retailSubscription = retailSubscription * quantity;
            wholesale = wholesale * quantity;
            wholesaleSales = wholesaleSales * quantity;
            wholesaleSubscription = wholesaleSubscription * quantity;
            const retailDiscount = retail * ((bundle.retailDiscount || 0) / 100);
            const wholesaleDiscount = wholesale * ((bundle.wholesaleDiscount || 0) / 100);

            const priceObjectWithoutDiscount = {
                retail,
                retailSales,
                retailSubscription,
                wholesale,
                wholesaleSales,
                wholesaleSubscription
            };

            const priceObject = {
                retail: retail - retailDiscount,
                retailSales,
                retailSubscription: retailSubscription - retailDiscount,
                wholesale: wholesale - wholesaleDiscount,
                wholesaleSales,
                wholesaleSubscription: wholesaleSubscription - wholesaleDiscount
            };

            const pointsObject = {
                subscription: {
                    cv: subscribeCV * quantity - (bundle.cvDiscount || 0),
                    pv: subscribePV * quantity - (bundle.pvDiscount || 0),
                    sb: subscribeSB * quantity - (bundle.sbDiscount || 0)
                },
                wholesale: {
                    cv: wholesaleCV * quantity - (bundle.cvDiscount || 0),
                    pv: wholesalePV * quantity - (bundle.pvDiscount || 0),
                    sb: wholesaleSB * quantity - (bundle.sbDiscount || 0)
                }
            };

            const promotions = {
                offerId,
                promotionClass,
                discount,
                message
            };

            return {
                points: pointsObject,
                price: priceObject,
                promotions: promotions,
                priceWithoutDiscount: priceObjectWithoutDiscount
            };
        }
    };

    const getPricing = async (quantity, okta, skuIfNotFirstVariant, selectedSkus) => {
        if (((data || {}).productDataSource || {}).source === "equinox") {
            if (!isNullOrFieldsEmpty(data.variants)) {
                let lastVariablePricing = {};
                for (const variant of data.variants) {
                    if (!skuIfNotFirstVariant || variant.sku === skuIfNotFirstVariant)
                        lastVariablePricing = await getEqPricing(variant, null, null, quantity, okta);
                }
                return lastVariablePricing;
            } else if (!isNullOrEmpty(data.bundle)) {
                let bundlePricing = await getEqPricing(null, data.bundle, selectedSkus, quantity, okta);
                return bundlePricing;
            } else {
                return {};
            }
        } else {
            if (!isNullOrFieldsEmpty(data.variants)) {
                let lastVariablePricing = {};
                for (const variant of data.variants) {
                    if (!skuIfNotFirstVariant || variant.sku === skuIfNotFirstVariant)
                        lastVariablePricing = await getCsPricing(variant, null, null, quantity, okta, data.productDataSource.market);
                }
                return lastVariablePricing;
            } else if (!isNullOrEmpty(data.bundle)) {
                let bundlePricing = await getCsPricing(null, data.bundle, selectedSkus, quantity, okta, data.productDataSource.market);
                return bundlePricing;
            } else {
                return {};
            }
        }
    };

    const updateBundleAttributes = (selectedSkus) => {
        if (!isNullOrEmpty(data.bundle)) {
            selectedSkus = selectedSkus || [];
            let latestBODate = null;
            let isBackordered = false;
            let availableQuantity = data.bundle.availableQuantity;
            let maxQuantity = data.bundle.maxQuantity;
            let dangerousGoods = false;
            let statusIsSellable = true;
            let availableQuantities = [];
            let maxQuantities = [];
            let dangerousGoodsArr = [];
            let statusArr = [];
            for (const bundleItem of data.bundle.kitProducts) {
                const variants = bundleItem.product.variants || [];
                let variant = variants[0];
                if (variants.length > 0 && selectedSkus.some((r) => variants.map((s) => s.sku).includes(r))) {
                    variant = (variants.filter((v) => selectedSkus.includes(v.sku)) || [])[0] || variant;
                } else if (!bundleItem.isMandatory) {
                    variant = null;
                }
                if (variant) {
                    if ((variant.status || {}).isBackordered) {
                        isBackordered = true;
                        latestBODate =
                            latestBODate && latestBODate > variant.status.backorderedAvailableDate
                                ? latestBODate
                                : variant.status.backorderedAvailableDate;
                    }
                    availableQuantities.push(variant.availableQuantity);
                    maxQuantities.push(variant.maxQuantity);
                    dangerousGoodsArr.push(variant.dangerousGoods);
                    statusArr.push((variant.status || {}).status);
                }
            }
            availableQuantity = Math.min(...availableQuantities);
            maxQuantity = Math.min(...maxQuantities);
            dangerousGoods = dangerousGoodsArr.includes(true);
            statusArr.forEach((status) => {
                ["NOT_RELEASED_FOR_SALE", "STOP_STATUS", "DISCONTINUED", "inactive", "INACTIVE"].forEach(
                    (badStatus) => {
                        if (badStatus === status) {
                            statusIsSellable = false;
                        }
                    }
                );
            });
            const status = {
                status: statusIsSellable ? "sellable" : "inactive",
                isBackordered,
                backorderedAvailableDate: latestBODate
            };
            data.bundle.status = status;
            data.bundle.availableQuantity = availableQuantity;
            data.bundle.maxQuantity = maxQuantity;
            data.bundle.dangerousGoods = dangerousGoods;
            return { status, availableQuantity, maxQuantity, dangerousGoods };
        }
    };

    return { data, getPricing, updateBundleAttributes, getEqPricing, getCsPricing }; // getEqPricing and getCsPricing exported to help unit test them
};

const getPricingForId = async (id, market, language, quantity, environment, oktaToken, includedBundleSkus, useContentSource) => {
    if (!id || !market || !language) {
        return {};
    }
    const fromId = await getProduct({ fromId: id, market, language, env: environment || "test", useContentSource });
    const variantSku = id.match(/^\d{8}$/) ? id : null;
    const pricing = await fromId.getPricing(quantity || 1, oktaToken, variantSku, includedBundleSkus || [], useContentSource);
    return pricing;
};

const getPricingForSlug = async (slug, market, language, quantity, environment, oktaToken, includedBundleSkus, useContentSource) => {
    if (!slug || !market || !language) {
        return {};
    }
    const fromId = await getProduct({ fromSlug: slug, market, language, env: environment || "test", useContentSource });
    const pricing = await fromId.getPricing(quantity || 1, oktaToken, null, includedBundleSkus || []);
    return pricing;
};

module.exports = {
    getPDPStrings,
    getProduct,
    getPricingForId,
    getPricingForSlug,
    getPublishedProducts,
    setActiveSalesEvents,
    getProductsById,
    getCPStrings
};
